<template>
  <div id="drawer">
    <v-app-bar app>
      <div class="row justify-content-between align-items-center">
        <div class="col app-bar-display">
          <v-btn outlined icon color="primary" large class="rounded-lg" @click.stop="drawer = !drawer"><i
              class="fas fa-bars font16px"></i></v-btn>
        </div>
        <div class="col black--text text-center"><i class="fas fa-circle primary-text ml-2"></i><span
            class="font-title">{{ titles }}</span></div>
        <div class="col app-bar-display text-left "><img src="../../assets/img/logo2.png" class="logo-height"
                                                         alt="لوگوی اتوماسیون">
        </div>
      </div>
    </v-app-bar>

    <v-navigation-drawer app right mobile-breakpoint="769"
                         class="sideBarNavigation-bg accent-4" v-model="drawer"
                         color="whiteMainColor"
    >
      <div class="py-3 d-flex justify-content-center">
        <img src="../../assets/img/logo2.png" contain height="80">
      </div>
      <div class="mt-7 mr-6">
        <router-link to="Dashboard">
          <i class="fas fa-circle font-12 primary-text"> </i> <span
            class="black--text mr-2 font-weight-normal">داشبورد</span>
        </router-link>
      </div>
      <div class="mt-3">
        <v-expansion-panels accordion flat>
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="fas fa-angle-down"><i
                class="fas fa-circle primary-text font-12"><span
                class="black--text mr-2 font-weight-normal">مدیریت بنر</span>
            </i></v-expansion-panel-header>
            <v-expansion-panel-content class="mr-3">
              <div class="mt-2">
                <router-link :to="{path:'defineBanner', query:{isNew : true}}">
                  <i class="fas fa-circle primary-text fa-xs"><span
                      class="black--text mr-2 font-weight-normal ">تعریف </span>
                  </i>
                </router-link>
              </div>
              <div class="mt-2">
                <router-link to="listBanners">
                  <i class="fas fa-circle primary-text fa-xs"><span
                      class="black--text mr-2 font-weight-normal ">لیست </span>
                  </i>
                </router-link>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
      <div>
        <v-expansion-panels accordion flat>
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="fas fa-angle-down" class="white--text"><i
                class="fas fa-circle primary-text font-12"><span
                class="black--text mr-2 font-weight-normal">مدیریت صفحات</span>
            </i></v-expansion-panel-header>
            <v-expansion-panel-content class="mr-3">
              <div class="mt-2">
                <router-link :to="{path:'definePages' , query:{isNew :true}}">
                  <i class="fas fa-circle primary-text fa-xs"><span
                      class="black--text mr-2 font-weight-normal ">تعریف</span>
                  </i>
                </router-link>
              </div>
              <div class="mt-2">
                <router-link to="listPages">
                  <i class="fas fa-circle primary-text fa-xs"><span
                      class="black--text mr-2 font-weight-normal">لیست</span>
                  </i>
                </router-link>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <div>
          <v-expansion-panels accordion flat>
            <v-expansion-panel>
              <v-expansion-panel-header expand-icon="fas fa-angle-down" class="white--text"><i
                  class="fas fa-circle primary-text font-12"><span
                  class="black--text mr-2 font-weight-normal">مدیریت اعضا</span>
              </i></v-expansion-panel-header>
              <v-expansion-panel-content class="mr-3">
                <div class="mt-2">
                  <router-link :to="{path: 'setUser', query:{isNew:true}}">
                    <i class="fas fa-circle primary-text fa-xs"><span
                        class="black--text mr-2 font-weight-normal "> تعریف </span>
                    </i>
                  </router-link>
                </div>
                <div class="mt-2">
                  <router-link :to="{path: 'listUsers'}">
                    <i class="fas fa-circle primary-text fa-xs"><span
                        class="black--text mr-2 font-weight-normal "> لیست  </span>
                    </i>
                  </router-link>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div>
          <v-expansion-panels accordion flat>
            <v-expansion-panel>
              <v-expansion-panel-header expand-icon="fas fa-angle-down" class="white--text"><i
                  class="fas fa-circle primary-text font-12"><span
                  class="black--text mr-2 font-weight-normal"> دسته بندی تیکت</span>
              </i></v-expansion-panel-header>
              <v-expansion-panel-content class="mr-3">
                <div class="mt-2">
                  <router-link :to="{path: 'ticketsCategory', query:{isNew:true}}">
                    <i class="fas fa-circle primary-text fa-xs"><span
                        class="black--text mr-2 font-weight-normal "> تعریف </span>
                    </i>
                  </router-link>
                </div>
                <div class="mt-2">
                  <router-link :to="{path: 'listCategoryTickets'}">
                    <i class="fas fa-circle primary-text fa-xs"><span
                        class="black--text mr-2 font-weight-normal"> لیست  </span>
                    </i>
                  </router-link>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div>
          <v-expansion-panels accordion flat>
            <v-expansion-panel>
              <v-expansion-panel-header expand-icon="fas fa-angle-down" class="white--text"><i
                  class="fas fa-circle primary-text font-12"><span
                  class="black--text mr-2 font-weight-normal">مدیریت تیکت ها</span>
              </i></v-expansion-panel-header>
              <v-expansion-panel-content class="mr-3">
                <div class="mt-2">
                  <router-link :to="{path: 'defineTicket', query:{isNew:true}}">
                    <i class="fas fa-circle primary-text fa-xs"><span
                        class="black--text mr-2 font-weight-normal "> تعریف </span>
                    </i>
                  </router-link>
                </div>
                <div class="mt-2">
                  <router-link :to="{path: 'listTicketsAdmin'}">
                    <i class="fas fa-circle primary-text fa-xs"><span
                        class="black--text mr-2 font-weight-normal "> لیست  </span>
                    </i>
                  </router-link>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div>
          <v-expansion-panels accordion flat>
            <v-expansion-panel>
              <v-expansion-panel-header expand-icon="fas fa-angle-down" class="white--text"><i
                  class="fas fa-circle primary-text font-12"><span
                  class="black--text mr-2 font-weight-normal">دسته بندی کار</span>
              </i></v-expansion-panel-header>
              <v-expansion-panel-content class="mr-3">
                <div class="mt-2">
                  <router-link :to="{path: 'defineTaskCategory', query:{isNew:true}}">
                    <i class="fas fa-circle primary-text fa-xs"><span
                        class="black--text mr-2 font-weight-normal "> تعریف </span>
                    </i>
                  </router-link>
                </div>
                <div class="mt-2">
                  <router-link :to="{path: 'listCategoryTasks'}">
                    <i class="fas fa-circle primary-text fa-xs"><span
                        class="black--text mr-2 font-weight-normal "> لیست  </span>
                    </i>
                  </router-link>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div>
          <v-expansion-panels accordion flat>
            <v-expansion-panel>
              <v-expansion-panel-header expand-icon="fas fa-angle-down" class="white--text"><i
                  class="fas fa-circle primary-text font-12"><span
                  class="black--text mr-2 font-weight-normal">مدیریت کار</span>
              </i></v-expansion-panel-header>
              <v-expansion-panel-content class="mr-3">
                <div class="mt-2">
                  <router-link :to="{path: 'defineTask', query:{isNew:true}}">
                    <i class="fas fa-circle primary-text fa-xs"><span
                        class="black--text mr-2 font-weight-normal "> تعریف </span>
                    </i>
                  </router-link>
                </div>
                <div class="mt-2">
                  <router-link :to="{path: 'listTasks'}">
                    <i class="fas fa-circle primary-text fa-xs"><span
                        class="black--text mr-2 font-weight-normal "> لیست  </span>
                    </i>
                  </router-link>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div>
          <v-expansion-panels accordion flat>
            <v-expansion-panel>
              <v-expansion-panel-header expand-icon="fas fa-angle-down" class="white--text"><i
                  class="fas fa-circle primary-text font-12"><span
                  class="black--text mr-2 font-weight-normal">دسته بندی پایگاه دانش</span>
              </i></v-expansion-panel-header>
              <v-expansion-panel-content class="mr-3">
                <div class="mt-2">
                  <router-link :to="{path: 'KnowledgeCategory', query:{isNew:true}}">
                    <i class="fas fa-circle primary-text fa-xs"><span
                        class="black--text mr-2 font-weight-normal "> تعریف </span>
                    </i>
                  </router-link>
                </div>
                <div class="mt-2">
                  <router-link :to="{path: 'listKnowledgeCategory'}">
                    <i class="fas fa-circle primary-text fa-xs"><span
                        class="black--text mr-2 font-weight-normal "> لیست  </span>
                    </i>
                  </router-link>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div>
          <v-expansion-panels accordion flat>
            <v-expansion-panel>
              <v-expansion-panel-header expand-icon="fas fa-angle-down" class="white--text"><i
                  class="fas fa-circle primary-text font-12"><span
                  class="black--text mr-2 font-weight-normal"> پایگاه دانش</span>
              </i></v-expansion-panel-header>
              <v-expansion-panel-content class="mr-3">
                <div class="mt-2">
                  <router-link :to="{path: 'knowledgeBase', query:{isNew:true}}">
                    <i class="fas fa-circle primary-text fa-xs"><span
                        class="black--text mr-2 font-weight-normal "> تعریف </span>
                    </i>
                  </router-link>
                </div>
                <div class="mt-2">
                  <router-link :to="{path: 'listKnowledge'}">
                    <i class="fas fa-circle primary-text fa-xs"><span
                        class="black--text mr-2 font-weight-normal "> لیست  </span>
                    </i>
                  </router-link>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>
      <div>
        <v-expansion-panels accordion flat>
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="fas fa-angle-down" class="white--text"><i
                class="fas fa-circle primary-text font-12"><span
                class="black--text mr-2 font-weight-normal">شبکه های اجتماعی</span>
            </i></v-expansion-panel-header>
            <v-expansion-panel-content class="mr-3">
              <div class="mt-2">
                <router-link :to="{path:'defineSocial' , query:{isNew :true}}">
                  <i class="fas fa-circle primary-text fa-xs"><span
                      class="black--text mr-2 font-weight-normal ">تعریف</span>
                  </i>
                </router-link>
              </div>
              <div class="mt-2">
                <router-link to="listSocials">
                  <i class="fas fa-circle primary-text fa-xs"><span
                      class="black--text mr-2 font-weight-normal">لیست</span>
                  </i>
                </router-link>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
<!--      <div>
        <v-expansion-panels accordion flat>
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="fas fa-angle-down" class="white&#45;&#45;text"><i
                class="fas fa-circle primary-text font-12"><span
                class="black&#45;&#45;text mr-2 font-weight-normal">مدیریت اعضا</span>
            </i></v-expansion-panel-header>
            <v-expansion-panel-content class="mr-3">
              <div class="mt-2">
                <router-link :to="{path: 'setUser', query:{isNew:true}}">
                  <i class="fas fa-circle primary-text fa-xs"><span
                      class="black&#45;&#45;text mr-2 font-weight-normal "> تعریف </span>
                  </i>
                </router-link>
              </div>
              <div class="mt-2">
                <router-link :to="{path: 'listUsers'}">
                  <i class="fas fa-circle primary-text fa-xs"><span
                      class="black&#45;&#45;text mr-2 font-weight-normal "> لیست  </span>
                  </i>
                </router-link>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>-->
      <div v-if="$getUserData().role === 1 || $getUserData().role === 2" class="mt-2 mr-6">
        <router-link to="appSetting">
          <i class="fas fa-circle primary-text font-12"> <span
              class="black--text mr-2 font-weight-normal">تنظیمات</span> </i>
        </router-link>
      </div>
      <div class="mt-5 mr-6">
        <router-link to="profileAdmin">
          <i class="fas fa-circle primary-text font-12"> <span
              class="black--text mr-2 font-weight-normal">پروفایل</span> </i>
        </router-link>
      </div>
      <div class="mt-5 mr-6">
        <i class="fas fa-circle primary-text font-12"> <span
            class="black--text mr-2 font-weight-normal pointer" @click="logOutDialog"> خروج</span></i>
      </div>

    </v-navigation-drawer>
    <v-dialog
        v-model="dialogResult"
        hide-overlay
        width="500">
      <v-card>
        <v-card-title class="primary-bg py-2">
          <div class="row no-gutters align-items-center">
            <div class="col text-left ">
              <v-btn
                  color="primary"
                  class="align-self-center"
                  icon
                  small
                  @click="dialogResult = false"
              >
                <v-icon small>fa-times</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-title>
        <v-card-text class="py-3">
          <div class="text-center black--text mt-5">
            {{ result }}
          </div>
          <div class="text-center mt-5">
            <v-btn
                color="primary"
                class="cards-btn"
                rounded
                outlined
                elevation="0"
                @click="signOut"
            >
              بله
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "navigationDrawer",
  props: ['titles'],
  data: () => ({
    drawer: false,
    dialogResult: false,
    result: null,
  }),
  mounted() {
    if (window.innerWidth > 769) {
      this.drawer = true
    }
  },
  methods: {
    logOutDialog() {
      this.result = 'آیا میخواهید از حساب کاربری خود خارج شوید؟'
      this.dialogResult = true
    },
    signOut() {
      this.$setUserData('', '', '', '')
      this.$router.replace('/')
    }
  }
}
</script>

<style scoped>

</style>